<template>
  <v-container class="py-0 max-width-1200">
    <v-row class="text-center">
      <v-col class="headline text-uppercase pb-0">
        {{ $t("partners.title") }}
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col class="display-1 text-center pt-0 mb-4">
        {{ $t("partners.subtitle") }}
      </v-col>
    </v-row>
    <v-row class="pb-8 text-left justify-center">
      <!-- <v-col
        v-for="(item,index) in partners"
        :key="index"
        cols="12" sm="6" md="4"
        class="mb-4">
        <v-row>
          <v-col cols="12">
            <img
              :src="item.img"
              loading="lazy"
              height="30"
              style="object-fit:contain;">
          </v-col>
          <v-col cols="12">
            {{ $t(item.text) }}
          </v-col>
        </v-row>
      </v-col> -->

        <v-slide-group
          v-model="model"
          class="pa-4"
          center-active
          show-arrows>
          <v-slide-item
            v-for="(item,index) in partners"
            :key="index"
            v-slot="{ active, toggle }">
            <v-card
              class="ma-4"
              height="240"
              width="240"
              flat
              @click="toggle">
                <v-col cols="12">
                  <img
                    :src="item.img"
                    loading="lazy"
                    :alt="item.name + 'logó'"
                    height="30" :width="item.width"
                    style="object-fit:contain;">
                </v-col>
                <v-col cols="12" class="pt-0">
                  {{ $t(item.text) }}
                </v-col>
            </v-card>

          </v-slide-item>
        </v-slide-group>

    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Promo',
    extends: DataComponentBase,

    data: () => ({
      model: null,
      partners: [
        { img: require("@/assets/partners/partner_magyartelekom.png"),         name: "Magyar Telekom",          text: 'partners.telekom.text',            width: '128' },
        { img: require("@/assets/partners/partner_grafisoft.png"),             name: "grafiSoft",               text: 'partners.grafiSoft.text',          width: '90' },
        { img: require("@/assets/partners/partner_vodafone.png"),              name: "Vodafone",                text: 'partners.vodafone.text',           width: '123' },
        { img: require("@/assets/partners/partner_antennahungaria.png"),       name: "Antenna Hungária",        text: 'partners.antennaHungaria.text',    width: '86' },
        { img: require("@/assets/partners/partner_bkvVszj.png"),               name: "BKV VSZJ",                text: 'partners.bkv.text',                width: '43' },
        { img: require("@/assets/partners/partner_flex.png"),                  name: "FLEX",                    text: 'partners.flex.text',               width: '73' },
        // { img: require("@/assets/partners/partner_opten.png"),                 name: "Opten",                   text: 'partners.opten.text',           width: '' },
        { img: require("@/assets/partners/partner_origostudios.png"),          name: "Origo",                   text: 'partners.origo.text',              width: '90' },
        { img: require("@/assets/partners/partner_uzsokiKorhaz.png"),          name: "Uzsoki Kórház",           text: 'partners.uzsokiKorhaz.text',       width: '37' },
        { img: require("@/assets/partners/partner_wewalka.png"),               name: "Wewalka",                 text: 'partners.wewalka.text',            width: '53' },
        // { img: require("@/assets/partners/partner_wipro.png"),                 name: "wipro",                   text: 'partners.wipro.text',           width: '' },
        { img: require("@/assets/partners/partner_elmu.png"),                  name: "Elmű",                    text: 'partners.elmu.text',               width: '88' },
        { img: require("@/assets/partners/partner_eon.png"),                   name: "EON",                     text: 'partners.eon.text',                width: '103' },
      ],
    }),
  }
</script>
